'use client'

import { defaultStyles, FileIcon as ReactFileIcon } from 'react-file-icon'
import { getFileExtension } from '@/lib/utils'
import { FileType } from '@/types/file'

type PropsType = {
  file: FileType
}

const ContentFileIcon = ({ file }: PropsType) => {
  return (
    <ReactFileIcon
      extension={getFileExtension(file.path)}
      {...(defaultStyles[getFileExtension(file.path) as keyof typeof defaultStyles] || {})}
    />
  )
}

export default ContentFileIcon
